var __jsx = React.createElement;
import React from "react";
import { Icon } from "@syarahtech/ui";
var RequirementItem = function RequirementItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement("div", {
    className: "py-2 px-3 bg-white rounded-lg flex justify-between items-center overflow-hidden shadow-[0_0_6px_0_rgba(74,74,74,0.04)] h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#E5ECF4] w-8 h-8 rounded-full flex items-center justify-center shrink-0"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: item === null || item === void 0 ? void 0 : item.icon,
    width: 5,
    height: 5,
    className: "text-primary-old"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-xs font-bold"
  }, item.title)), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-sm font-medium"
  }, item.description));
};
export default RequirementItem;